import { render, staticRenderFns } from "./GrammarInfoHighlighter.vue?vue&type=template&id=4995e66a&"
import script from "./GrammarInfoHighlighter.vue?vue&type=script&lang=ts&"
export * from "./GrammarInfoHighlighter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports